import { render, staticRenderFns } from "./smsTariffPicker.vue?vue&type=template&id=50637276&scoped=true"
import script from "./smsTariffPicker.vue?vue&type=script&lang=js"
export * from "./smsTariffPicker.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50637276",
  null
  
)

export default component.exports